<form #removeForm="ngForm" (ngSubmit)="apply()" novalidate>
  <h2 mat-dialog-title>Adding privileges for:</h2>
  <mat-dialog-content>
    <div class="pairs">
      <div class="row" *ngIf="recipient">
        <span class="label">Recipient:</span>
        <span class="value">{{ recipient!.id }}</span>
        <span class="flex">{{ recipient.firstName || "" }}</span>
      </div>
    </div>

    <ng-container>
      <mat-form-field>
        <mat-select placeholder="Application for:" [(ngModel)]="selectedPrivilege" required name="selectedPrivilege" (selectionChange)="onPrivilegeChange()">
          <mat-option *ngFor="let privilege of privileges" [value]="privilege">
            {{ approvalColumnLabels[privilege] }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <!-- Value Input -->
    <ng-container *ngIf="showValueInput">
      <mat-form-field *ngIf="showTextInput">
        <input matInput placeholder="Enter value" [(ngModel)]="value" required name="valueInput" [type]="isNumericInput(selectedPrivilege) ? 'number' : 'text'" />
      </mat-form-field>
    </ng-container>

    <mat-form-field *ngIf="this.selectedPrivilege">
      <input matInput placeholder="Enter reason for approval" [(ngModel)]="approvalReason" name="approvalReasonInput" />
    </mat-form-field>

    <ng-template #willRemove>
      <i>Are you sure you want to apply a request for this recipient?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!removeForm.valid">Request</button>
  </mat-dialog-actions>
</form>
